import { computed } from 'nanostores';

export function computeStateForCurrentChat(
  store,
  { chatId, currentUser = {}, lastMessageReceivedAwayFromBottomAt }
) {
  return computed(store, storeValue => {
    const chat = storeValue.chats.get(chatId) || {};

    return addComputedPropsToChat(
      chat,
      currentUser,
      lastMessageReceivedAwayFromBottomAt
    );
  });
}

export function addComputedPropsToChat(chat, currentUser = {}) {
  const sorted = extractMessages(chat).sort(sortByCreatedAt);

  const first = sorted.at(0);
  const last = sorted.at(-1);

  const sentMessages = sorted.filter(
    m => !m.errors && m.kind !== 'system' && (m.receivedAt || m.savedAt)
  );
  const firstSentMessage = sentMessages.at(0);
  const lastSentMessage = sentMessages.at(-1);

  const unreadMessages = getUnreadMessages(sorted, currentUser.id);

  const unreadMessagesCount = chat.unreadMessagesCount || 0;

  const hasUnreadMessages = unreadMessagesCount > 0;

  const myLastWrittenMessage = getMyLastWrittenMessage(sorted, currentUser.id);

  const myMessages = sorted.filter(m => m.userId === currentUser.id);

  const unsentMessages = getUnsentMessages(myMessages);

  const isMyMessageLast = last && last === myLastWrittenMessage;

  // Math.max is used to avoid negative values
  const unreadMessagesToLoadCount = Math.max(
    0,
    unreadMessagesCount - unreadMessages.length
  );

  return {
    ...chat,
    sorted,
    first,
    last,
    firstSentMessage,
    lastSentMessage,
    unreadMessages,
    unreadMessagesCount,
    unreadMessagesToLoadCount,
    hasUnreadMessages,
    myLastWrittenMessage,
    myMessages,
    unsentMessages,
    isMyMessageLast,
  };
}

function sortByCreatedAt(m1, m2) {
  return m1.createdAt > m2.createdAt ? 1 : -1;
}

function getUnreadMessages(messages, userId) {
  return messages.filter(
    m =>
      !m.readIds?.includes(userId) && // not read by me
      m.userId !== userId && // not my own messages
      m.kind !== 'system' // not system messages
  );
}

function extractMessages(chat) {
  return chat.messages ? [...chat.messages.values()] : [];
}

function getMyLastWrittenMessage(messages, userId) {
  return messages.findLast(m => m.userId === userId);
}

function getUnsentMessages(messages) {
  return messages.filter(m => !m.receivedAt && !m.savedAt);
}

export function getNewMessages(messages, lastMessageReceivedAwayFromBottomAt) {
  if (!lastMessageReceivedAwayFromBottomAt) return [];

  return messages.filter(
    m => m.receivedAt >= lastMessageReceivedAwayFromBottomAt
  );
}
